import { Divider, Row } from 'antd';
import styled from 'styled-components';

export const ContainerBrand = styled(Row)`
  height: 70px;
  justify-content: center;
  align-items: center;
`;

export const DividerMenu = styled(Divider)`
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin: 0px 0px 10px 0px;
  min-width: initial;

  width: ${props => {
    if (props.iscollapsed === 'true') return '100%';
    return '90%';
  }};

  margin-left: ${props => {
    if (props.iscollapsed === 'true') return 0;
    return '10px';
  }};
`;
